import classNames from 'classnames'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import { UI2TextProps, UI2_TEXT_DEFAULT_PROPS } from 'shared-libs/components/ui2/display/ui2-text/ui2-text-props'
import { translateString } from 'shared-libs/helpers/utils'

import './_ui2-text.scss'

export const UI2Text: React.FC<UI2TextProps> = (props) => {
  const resolvedProps = { ...UI2_TEXT_DEFAULT_PROPS, ...props}
  const { text, markdownText, variant, tone, translationTable, frames } = resolvedProps

  const resolvedTable = Object.assign({}, frames?.getContext('translationTable'), translationTable)
  const className = classNames('ui2-text', `ui2-text--${variant}`, `ui2-text--${tone}`)

  if (markdownText) {
    const translated = translateString(markdownText, resolvedTable) ?? markdownText
    return (
      <div className={className}>
        <ReactMarkdown>{translated}</ReactMarkdown>
      </div>
    )
  }

  const translated = text ? translateString(text, resolvedTable) ?? text : ''
  return <div className={className}>{translated}</div>
}
